import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { PluralatePipe } from './pluralate-pipe';

@Injectable({
    providedIn: 'root'
})
@Pipe({standalone: true,  name: 'secondsToDHM', pure: false })
export class SecondsToDHMPipe implements PipeTransform {
    constructor(
        private pluralate: PluralatePipe,
    ) {

    }

    public transform(seconds: any, short = false, ignoreSeconds = false, daysToHours = true): string {
        if (0 === seconds) {
            return '';
        }

        let formatted = '';

        // calculate (and subtract) whole days
        let daysString = '';
        let hoursString = '';
        let minutesString = '';
        let secondsString = '';

        if (!daysToHours) {
            const days = Math.floor(seconds / 86400);
            seconds -= days * 86400;
            if (days > 0) {
                daysString = this.pluralate.transform(days, short ? 'DHM.DAYS.SHORT' : 'DHM.DAYS.LONG');
                formatted += `${days} ${daysString} `;
            }
        }

        // calculate (and subtract) whole hours
        let hours = Math.floor(seconds / 3600);
        if (!daysToHours) {
            hours = hours % 24;
        }
        seconds -= hours * 3600;

        if (hours > 0) {
            hoursString = this.pluralate.transform(hours, short ? 'DHM.HOURS.SHORT' : 'DHM.HOURS.LONG');
            formatted += `${hours} ${hoursString} `;
        }

        // calculate (and subtract) whole minutes
        const min = Math.floor(seconds / 60) % 60;
        seconds -= min * 60;
        if (min > 0) {
            minutesString = this.pluralate.transform(min, short ? 'DHM.MINUTES.SHORT' : 'DHM.MINUTES.LONG');
            formatted += `${min} ${minutesString}`;
        }

        // calculate (and subtract) whole seconds
        const sec = Math.floor(seconds) % 60;
        if (!ignoreSeconds && sec > 0) {
            secondsString = this.pluralate.transform(sec, short ? 'DHM.SECONDS.SHORT' : 'DHM.SECONDS.LONG');
            formatted += ` ${sec} ${secondsString}`;
        }

        return formatted;
    }
}
